import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { DashboardLayout } from "@/components/dashboard/DashboardLayout";
import { useDashboardContext } from "@/components/dashboard/DashboardContext";
import { LoadingScreen } from "@/components/LoadingScreen";

export const Route = createFileRoute("/dashboard/members")({
	component: LegacyWorkspaceSettingsRedirect,
});

function LegacyWorkspaceSettingsRedirect() {
	const navigate = useNavigate();
	const { workspace, isWorkspacesLoading } = useDashboardContext();

	useEffect(() => {
		if (isWorkspacesLoading || !workspace) return;
		navigate({
			to: "/dashboard/workspaces/$workspaceSlug/settings",
			params: { workspaceSlug: workspace.slug },
			replace: true,
		});
	}, [isWorkspacesLoading, navigate, workspace]);

	return (
		<DashboardLayout className="flex items-center justify-center">
			<LoadingScreen />
		</DashboardLayout>
	);
}
